import * as React from 'react'
import type { SVGProps } from 'react'
const SvgLogoStandalone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={20}
    fill="none"
    viewBox="0 0 24 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.635 12.388a2.27 2.27 0 0 0-.113-.722 1.717 1.717 0 0 0-1.94-1.11c-.814.152-1.411.867-1.413 1.714-.003 2.138-.002 4.275-.001 6.413a1.277 1.277 0 1 1-2.554 0c0-2.182-.002-4.363.004-6.545.001-.292.039-.59.098-.877.43-2.06 2.38-3.513 4.495-3.36 2.108.151 3.85 1.85 3.95 3.947.041.849.05 2.31.053 3.38a1.336 1.336 0 0 1-1.325 1.326c-.688 0-1.251-.55-1.254-1.238-.003-.976.01-1.953 0-2.929"
    />
    <path
      fill="currentColor"
      d="M22.595 16.555a1.236 1.236 0 0 1-1.25-1.245c0-.936-.002-2.173-.013-2.894a10.15 10.15 0 0 0-.124-1.59c-.878-4.998-5.365-8.363-10.394-7.81-4.296.472-7.77 3.931-8.276 8.246-.074.628-.581 1.114-1.213 1.114H1.23c-.727 0-1.292-.589-1.225-1.313.028-.3.061-.59.097-.793C1.353 3.204 8.597-1.255 15.427.944c4.651 1.497 7.412 4.772 8.32 9.586.128.682.15 3.171.15 4.729 0 .718-.584 1.296-1.302 1.296"
    />
    <path
      fill="currentColor"
      d="M17.455 12.302a7.5 7.5 0 0 0-.056-.906c-.42-3.153-3.529-5.33-6.636-4.653-2.62.571-4.418 2.81-4.423 5.522-.004 2.135-.001 4.27 0 6.406a1.276 1.276 0 1 1-2.553 0c-.002-2.11-.005-4.221.006-6.331.003-.497.05-1 .13-1.49.713-4.352 5.042-7.383 9.38-6.579 3.944.731 6.706 4.048 6.707 8.055 0 .914.01 4.421.018 6.363.003.713-.59 1.31-1.303 1.31a1.246 1.246 0 0 1-1.247-1.242l-.022-6.454Z"
    />
  </svg>
)
export default SvgLogoStandalone
